import { render, staticRenderFns } from "./messagelist.vue?vue&type=template&id=afb1686a&"
import script from "./messagelist.vue?vue&type=script&lang=js&"
export * from "./messagelist.vue?vue&type=script&lang=js&"
import style0 from "./messagelist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports